import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export function PublicNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'el' : 'en');
  };

  return (
    <nav className="nav-sticky bg-gradient-to-r from-[#1756E0] to-[#4EA1FF] text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold hover:scale-[1.02] transition-transform">
              {t('common:nav.brand')}
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/pricing"
              className="nav-underline relative px-3 py-2 text-sm font-medium hover:text-blue-100 transition-colors"
            >
              {t('common:nav.pricing')}
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              className="px-3 py-1.5 text-sm font-medium hover:bg-white/10 rounded-lg transition-colors flex items-center gap-2"
            >
              {language === 'en' ? (
                <>
                  <span className="text-lg">🇬🇧</span>
                  <span>EN</span>
                </>
              ) : (
                <>
                  <span className="text-lg">🇬🇷</span>
                  <span>ΕΛ</span>
                </>
              )}
            </button>

            <Link
              to="/login"
              className="px-4 py-2 text-sm font-medium hover:bg-white/10 rounded-lg transition-colors"
            >
              {t('common:nav.login')}
            </Link>

            <Link
              to="/register"
              className="px-4 py-2 text-sm font-medium bg-white text-blue-600 hover:bg-blue-50 rounded-lg transition-colors shadow-lg hover:shadow-xl"
            >
              {t('common:nav.register')}
            </Link>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-lg hover:bg-white/10 transition-colors"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-blue-700/95 backdrop-blur-lg">
          <div className="px-4 pt-2 pb-4 space-y-2">
            <Link
              to="/pricing"
              className="block px-3 py-2 text-base font-medium hover:bg-white/10 rounded-lg transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('common:nav.pricing')}
            </Link>

            <button
              onClick={() => {
                toggleLanguage();
                setIsMenuOpen(false);
              }}
              className="w-full text-left px-3 py-2 text-base font-medium hover:bg-white/10 rounded-lg transition-colors flex items-center gap-2"
            >
              {language === 'en' ? (
                <>
                  <span className="text-lg">🇬🇧</span>
                  <span>English</span>
                </>
              ) : (
                <>
                  <span className="text-lg">🇬🇷</span>
                  <span>Ελληνικά</span>
                </>
              )}
            </button>

            <Link
              to="/login"
              className="block px-3 py-2 text-base font-medium hover:bg-white/10 rounded-lg transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('common:nav.login')}
            </Link>

            <Link
              to="/register"
              className="block px-3 py-2 text-base font-medium bg-white text-blue-600 hover:bg-blue-50 rounded-lg transition-colors shadow-lg text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              {t('common:nav.register')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
